import { Logo } from './Logo';

export function Loading({ label = 'Đang tải Kidee…' }: { label?: string }) {
  return (
    <div className="loading-screen" role="status">
      <Logo />
      <div className="spinner" />
      <p>{label}</p>
    </div>
  );
}
